import {transpose, convertRowsToData} from '../utils/dataUtils'
import { stack as d3_stack, stackOffsetDiverging as d3_stackOffsetDiverging } from 'd3-shape'
import { extent as d3_extent, max as d3_max, min as d3_min } from 'd3-array'
export default function LineAndBarDataController (rows,config,hiddenItems) {
  

  let headers = rows[0]
  let propperHeaders
  propperHeaders = ['id',...headers.slice(1)]

  // En el explorer siempre viene el "rolesRow"
  // Sino, puede que venga una config "roleDict"
  // Sino lo constriumos como "bar, line, line, line..."
  let rolesRow = rows.find((r)=>r[0]==='_ROLE_')
  let roleDict
  
  if(config.roleDict){
    roleDict = config.roleDict
  } else if(rolesRow) {
    roleDict = rolesRow.reduce((res,role,i)=>{
      if(role!=='_ROLE_') res[propperHeaders[i]] = role
      return res
    },{})
  } else {
    roleDict = propperHeaders.slice(1).reduce((res, col, i)=>{
      res[col] = i===0 ? 'bar' : 'line'
      return res
    },{})
  }
  
  let data = convertRowsToData([propperHeaders,...rows.slice(rolesRow?2:1)],headers.length-1)
  

  let barIds = propperHeaders.filter((d,i)=>roleDict[d]==='bar')
  let lineIds = propperHeaders.filter((d,i)=>roleDict[d]==='line')
  let lines = data.map((d)=>{
    return {
      id: d.id,
      value: lineIds.map((lineId)=>{
        return {
          id: lineId,
          parentId: d.id,
          value: +d.value.find((dd)=>dd.id===lineId).value
        }
      })
    }
  })
  //BULLCRAP!!! NO ENTIENDO PORQUE HAY QUE CAMBIAR LOS id/parentId...
  lines = transpose(lines)
  lines.forEach((line)=>{
    line.value.forEach((point)=>{
      point.id = point.parentId
      point.parentId = line.id
    })
  })
  if(hiddenItems) lines = lines.filter((d)=>hiddenItems.indexOf(d.id)<0)

  let barsExtent
  if (config.mode === 'stacked') {
    barsExtent = [
      d3_min(data, d => d3_min(d.value, dd => dd.value)),
      d3_max(data, d => d3_max(d.value, dd => dd.value)),
    ]
  } else {
    barsExtent = [
      d3_min(data, d => d3_min(d.value, dd => dd.value)),
      d3_max(data, d => d3_max(d.value, dd => dd.value)),
    ]
  } 
  if (barsExtent[0] > 0) barsExtent[0] = 0
  let extentSize = Math.abs(barsExtent[1] - barsExtent[0])
  let getSafeValue = v => {
    return v
    // return config.minBarHeight
    //   ? Math.sign(v || 1) * Math.max((extentSize * config.minBarHeight) / 100, Math.abs(v))
    //   : +v
  }

  let bars
  if (config.mode === 'stacked') {
    let barsData = data.map((row)=>{
      return {id: row.id,value: row.value.filter((col,i)=>roleDict[col.id]==='bar')}
    })
    let keys = barsData.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    if(hiddenItems) keys = keys.filter((d)=>hiddenItems.indexOf(d)<0)
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)

    let objArray = barsData.map(layer => {
      let res = { id: layer.id }
      layer.value.forEach(dd => {
        res[dd.id] = dd.value
      })
      return res
    })
    let stack = d3_stack()
      .value((d, key) => getSafeValue(d[key]))
      .keys(keys)
      .offset(d3_stackOffsetDiverging)

    let stacked = stack(objArray)
    let lastLayer = stacked[stacked.length-1]
    let firstLayer = stacked[0]
    
    let mins = firstLayer.reduce((mins,z,i)=>{
      stacked.forEach((layer)=>{
        if(layer[i][0]<mins[i]) mins[i] = layer[i][0]
      })
      return mins
    },new Array(firstLayer.length).fill(Infinity))

    let maxs = firstLayer.reduce((maxs,z,i)=>{
      stacked.forEach((layer)=>{
        if(layer[i][1]>maxs[i]) maxs[i] = layer[i][1]
      })
      return maxs
    },new Array(firstLayer.length).fill(-Infinity))
    
    let result = stacked.map(layer => {
      return {
        id: layer.key,
        index: layer.index,
        value: layer.map((dd,i) => {
          return {
            id: dd.data.id,
            value: dd.data[layer.key],
            safeValue: getSafeValue(dd.data[layer.key]),
            y0: dd[0],
            y1: dd[1],
            layerIndex: layer.index,
            isLastLayer: maxs[i] === dd[1], //keys.indexOf(layer.key) === keys.length - 1, // 
            isFirstLayer: mins[i] === dd[0], //keys.indexOf(layer.key) === 0, // 
            parentId: layer.key,
            // por arriba no hace falta...
            barMax: maxs[i], //lastLayer[i][1],
            // por abajo es guarro mirar el config y no poder mirar el "axis.y.scale.domain()"....
            // barMin: firstLayer[i][0],
            barMin: mins[i], //config.AxisHelper.y.domain[0]==='auto'?firstLayer[i][0]:-config.AxisHelper.y.domain[0] 
          }
        }),
      }
    })
    bars = result
  } else {
    bars = barIds.map((barId)=>{
      return {
        id: barId,
        value: data.map((d)=>{
          return {
            id: d.id,
            parentId: barId,
            value: +d.value.find((dd)=>dd.id===barId).value,
            safeValue:  +d.value.find((dd)=>dd.id===barId).value,
            // y0: +d.value.find((dd)=>dd.id===barId).value,
            // y1: +d.value.find((dd)=>dd.id===barId).value
          }
        })      
      }
    })
    bars.id = barIds[0]
  }
  bars.dimensions = config.simple && bars.map((b)=>b.id)
  return {lines,bars}
}